import regrasJuridicas from "../data/regrasJuridicas";

const motorJuridico = (descricao) => {

  const texto = Object.entries(descricao || {})
    .map(([key, value]) => `${key} ${value}`)
    .join(" ")
    .toLowerCase();
    
  const acoesDetectadas = [];
  const pedidos = new Set();
  const areas = new Set();

  for (let regra of regrasJuridicas) {

    let pontuacao = 0;

    for (let palavra of regra.palavras) {

      if (texto.includes(palavra)) {
        pontuacao++;
      }

    }

    if (pontuacao > 0) {

      acoesDetectadas.push(regra.acao);

      areas.add(regra.area);

      regra.pedidos.forEach(p => pedidos.add(p));

    }

  }

  return {

    areas: Array.from(areas),

    acoes: acoesDetectadas,

    pedidos: Array.from(pedidos)

  };

};

export default motorJuridico;